import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { RouterProvider } from "@tanstack/react-router";
import { AppProviders, bootApp, createAppRouter } from "@empite/app-kit";
// theme.css is the design system's globals.css verbatim: Tailwind's preflight
// plus the token layers every screen in this portal is now drawn from. The
// shared esm-* sheet used to be imported after it, ordered that way so the
// reset could not restyle a screen that already worked; no screen renders esm-*
// markup any more, so the portal no longer loads @empite/ui-components at all.
import "./theme.css";
import "./portal.css";
import { routeTree } from "./routes";

// Built once, at module scope. A QueryClient or a transport created inside a
// component is recreated on every render, which throws the cache away and
// turns a warm portal into a cold one.
const context = bootApp();
const router = createAppRouter({ routeTree, context });

const root = document.getElementById("root");
if (!root) {
  throw new Error("index.html is missing #root");
}

createRoot(root).render(
  <StrictMode>
    <AppProviders queryClient={context.queryClient} transport={context.transport}>
      <RouterProvider router={router} />
    </AppProviders>
  </StrictMode>,
);
